export default "__VITE_ASSET__Cgm2i2Ib__"